export default __webpack_public_path__ + "4448cc5a2c965f17d92f014cb61f0d58.svg";